import { createFileRoute, redirect } from '@tanstack/react-router'
import { PreferenceQueries, useSaveMenuTreeDetail } from '@admin/data'
import { useSuspenseQuery } from '@tanstack/react-query'
import MenuDesigner from '@migrate/components/admin/menuDesigner/MenuDesigner'
import { getUserNotificationStore } from '@migrate/stores'

export const Route = createFileRoute('/_auth/preferences/navigation-bar/')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Menu', 'WRITE')) {
      if (scopedEnablements.global().hasStandardEnablement('Organization', 'MANAGE')) {
        throw redirect({
          to: '/preferences/navigation-bar/org-logo',
          replace: true,
        })
      }
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(PreferenceQueries.menuTreeDetail()),
      queryClient.ensureQueryData(PreferenceQueries.rolesForMenus()),
    ])
  },
})

function RouteComponent() {
  const { data: menuTree } = useSuspenseQuery(PreferenceQueries.menuTreeDetail())
  const { data: rolesForMenus } = useSuspenseQuery(PreferenceQueries.rolesForMenus())
  const { mutateAsync: saveMenuTree } = useSaveMenuTreeDetail()

  return (
    <MenuDesigner
      menuLoader={() => Promise.resolve(menuTree)}
      roleLoader={() => Promise.resolve(rolesForMenus)}
      saver={saveMenuTree}
      userNotificationStore={getUserNotificationStore()}
      style={{ width: '100%' }}
    />
  )
}
